import React from "react";

const Footer = () => {
  return (
    <div
      style={{
        backgroundColor: "black",
        color: "white",
        padding: "20px",
        textAlign: "center",
        opacity: ".9",
      }}
    >
      <p>
        &copy; 2022 Copyright <strong>Sigma Soft</strong>{" "}
      </p>
    </div>
  );
};

export default Footer;
